/**
 * MetronomeIcon Component
 * SVG icon for metronome toggle button
 */

import React from 'react';

export const MetronomeIcon = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2L8 22h8L12 2z" />
    <path d="M12 6v10" />
    <circle cx="12" cy="18" r="2" fill="currentColor" />
    <path d="M12 8l4-2" />
  </svg>
);

export default MetronomeIcon;
